import { render, staticRenderFns } from "./clothOptions.vue?vue&type=template&id=dda5b864&scoped=true&"
import script from "./clothOptions.vue?vue&type=script&lang=js&"
export * from "./clothOptions.vue?vue&type=script&lang=js&"
import style0 from "./clothOptions.vue?vue&type=style&index=0&id=dda5b864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda5b864",
  null
  
)

export default component.exports